export enum TravelRiskPackageCode {
    MedicalExpenses = 'KEMI',
    Accident = 'KENA',
    Baggage = 'KEBA',
    CivilResponsibility = 'CTA',
    TripCancellation = 'KEKE',
}
